package org.braunequip.web.components.sections.Maintenance

import androidx.compose.runtime.*
import androidx.compose.runtime.snapshots.SnapshotStateList
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.braunequip.web.components.models.MaintItemsDTO
import org.braunequip.web.styles.AdminStyles.*
import org.braunequip.web.util.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun AssetMaintenanceItemsTable(
    assetMaintItems: SnapshotStateList<MaintItemsDTO>,
    onComplete: (MaintItemsDTO) -> Unit,
    onRead: (MaintItemsDTO) -> Unit,
    onDelete: (MaintItemsDTO) -> Unit,
    showMoreVisibility: Boolean,
    onShowMore: () -> Unit
) {

    Column(
        modifier = Modifier
            .fillMaxWidth() // Ensure it takes full width
            .maxWidth(100.percent) // Constrain width to prevent infinite expansion
            .overflow(Overflow.Auto)
            .border(1.px, LineStyle.Solid, Colors.Grey)
            .backgroundColor(Colors.White),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Box(
            modifier = Modifier
                .overflow(Overflow.Auto) // Enables horizontal scrolling
                .width(100.percent) // Ensures the container does not exceed screen width
        ) {
            Table(
                attrs = Modifier
                    .minWidth(800.px)
                    .fillMaxSize()
                    .classNames("table")
                    .margin(topBottom = 0.px)
                    .padding(topBottom = 0.px)
                    .toAttrs()
            ) {
                Thead(
                    Modifier
                    .toAttrs {
                        style {
                            property("table-layout", "fixed")
                        }
                    }
                ) {
                    Tr {
                        Th(
                            TableHeaderStyle.toModifier()
                                .then(SmallColumnStyle).toAttrs()) {
                            Text("Action")
                        }
                        Th(
                            TableHeaderStyle.toModifier()
                                //todo click schedule id
                                .then(SmallColumnStyle).toAttrs()) {
                            Text("Schedule ID")
                        }
                        Th(
                            TableHeaderStyle.toModifier()
                                //todo click schedule id
                                .then(MediumColumnStyle).toAttrs()) {
                            Text("Maintenance")
                        }
                        Th(
                            TableHeaderStyle.toModifier()
                                .then(MediumColumnStyle).toAttrs()) {
                            Text("Status")
                        }
                        Th(
                            TableHeaderStyle.toModifier()
                                .then(MediumColumnStyle)
                                .toAttrs()
                        ) {
                            Text("Due Miles")
                        }
                        Th(
                            TableHeaderStyle.toModifier()
                                .then(MediumColumnStyle)
                                .toAttrs()
                        ) {
                            Text("Due Date")
                        }
                        Th(
                            TableHeaderStyle.toModifier()
                                .then(MediumColumnStyle)
                                .toAttrs()
                        ) {
                            Text("Completed At")
                        }
                        Th(
                            TableHeaderStyle.toModifier()
                                .then(MediumColumnStyle).toAttrs()
                        ) {
                            Text("Created")
                        }
                    }
                }
                Tbody {
                    assetMaintItems.forEach { row ->
                        MaintItemPreview(
                            item = row,
                            onComplete = onComplete,
                            onRead = onRead,
                            onDelete = onDelete
                        )
                    }
                }
            }
        }

        SpanText(
            text = "Show More",
            modifier = ShowMoreButtonStyle.toModifier()
                .display(if (showMoreVisibility) DisplayStyle.Block else DisplayStyle.None)
                .onClick {
                    onShowMore()
                }
        )
    }
}

@Composable
fun MaintItemPreview(
    item: MaintItemsDTO,
    onComplete: (MaintItemsDTO) -> Unit,
    onRead: (MaintItemsDTO) -> Unit,
    onDelete: (MaintItemsDTO) -> Unit,
) {

    Tr() {
        Td(SmallColumnStyle
            .gap(5.px)
            .toAttrs()
        ) {
            Button(
                attrs = HoverSuccessButton.toModifier()
                    .borderRadius(4.px)
                    .width(25.px)
                    .height(25.px)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        onComplete(item)
                    }
                    .toAttrs(),
            ) {
                FaCheck()
            }

            Button(
                attrs = HoverWarningButton.toModifier()
                    .borderRadius(4.px)
                    .width(25.px)
                    .height(25.px)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        onRead(item)
                    }
                    .toAttrs(),
            ) {
                FaMagnifyingGlass()
            }

            Button(
                attrs = HoverBadButton.toModifier()
                    .borderRadius(4.px)
                    .width(25.px)
                    .height(25.px)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        onDelete(item)
                    }
                    .toAttrs(),
            ) {
                FaTrash()
            }
        }
        Td(SmallColumnStyle.toAttrs()) {
            Text(item.scheduleId.toString())
        }
        Td(MediumColumnStyle.toAttrs()) {
           Text(item.scheduleName.toString())
        }
        Td(MediumColumnStyle.toAttrs()) {
            item.status?.let {
                Text(parseMaintItemStatus(it).joinToString(", "))
            }
        }
        Td(MediumColumnStyle.toAttrs()) {
            Text(item.dueMiles?.pretty() ?: "-")
        }
        Td(MediumColumnStyle.toAttrs()) {
            Text(item.dueDate ?: "-")
        }
        Td(MediumColumnStyle.toAttrs()) {
            Text(item.completedDate?.let { formatDateTime(it) } ?: "-")
        }
        Td(MediumColumnStyle.toAttrs()) {
            item.createdAt?.let { formatDate(it) }?.let { Text(it) }
        }
    }
}
